module.exports = __webpack_public_path__ + "img/icon_fan_white.8941f2ad.svg";